var _module = require('../../components/module');
var lrutils = require('../../../libs/lrutils');

_module.service('$transform', [
    '$log',

    function transformService($log) {
        return {
            /*
            Used to take an array collection and mapping and create
            a new collection of objects.

            @function zipFunc
            @param {Array} mappings
            @param {Array} collection
            @returns {Array} - a mapped collection
            */
            zip: lrutils.zip.bind(lrutils),

            /*
            Used to take a mapped collection and convert it back
            to an Array of arrays.

            Example Return
            {
                mappings: [],
                collection: [[]]
            }

            @function unzip
            @param {Array} collection
            @param {Array} [mappings]
            @returns {Object}
            */
            unzip: lrutils.unzip.bind(lrutils)
        };
    }
]);
